import React, { useEffect, useState } from "react";
import "./Network_overview.css";
import { useAccount } from "wagmi";
import Web3 from "web3";
import { Staking_Abi, Staking_Address } from "../../util/Contract";

const Network_overview = () => {
  const { address } = useAccount();

  const [Stake_history, setStake_history] = useState({
    totalWithdrawanToken: 0,
    TotalStaker: 0,
    TotalStakedToken: 0,
    withdrawn: 0,
    realtimeReward: 0,
    rewardtobewithdraw: 0,
    tvl: 0,
  });
  let WebSupply = new Web3("https://eth-sepolia.public.blastapi.io");

  const Get_Stake_history = async () => {
    try {
      let stakingContractOf = new WebSupply.eth.Contract(
        Staking_Abi,
        Staking_Address
      );
    
      let tvl = await stakingContractOf.methods.totallockvalue().call();
      tvl = WebSupply.utils.fromWei(tvl.toString());
      tvl = parseFloat(tvl).toFixed(3);
      setStake_history((oldData) => {
        return { ...oldData, tvl: tvl };
      });

      let withdrawn = await stakingContractOf.methods.WITHDRAWN().call();
      withdrawn = WebSupply.utils.fromWei(withdrawn.toString());

      setStake_history((oldData) => {
        return { ...oldData, withdrawn: withdrawn };
      });

      let TotalStaker = await stakingContractOf.methods.totalStaker().call();
      setStake_history((oldData) => {
        return { ...oldData, TotalStaker: TotalStaker };
      });
      let TotalStakedToken = await stakingContractOf.methods
        .totalStakedToken()
        .call();
      TotalStakedToken = WebSupply.utils.fromWei(TotalStakedToken.toString());
      TotalStakedToken = parseFloat(TotalStakedToken).toFixed(3);
      setStake_history((oldData) => {
        return { ...oldData, TotalStakedToken: TotalStakedToken };
      });
      // let totalWithdrawanToken = await stakingContractOf.methods
      //   .totalWithdrawanToken()
      //   .call();
      // totalWithdrawanToken = WebSupply.utils.fromWei(
      //   totalWithdrawanToken.toString()
      // );
      // totalWithdrawanToken = parseFloat(totalWithdrawanToken).toFixed(3);
      // setStake_history((oldData) => {
      //   return { ...oldData, totalWithdrawanToken: totalWithdrawanToken };
      // });

      let rewardtobewithdraw = await stakingContractOf.methods
        .rewardtobewithdraw()
        .call();
      console.log("rewardtobewithdraw", rewardtobewithdraw);

      rewardtobewithdraw = WebSupply.utils.fromWei(
        rewardtobewithdraw.toString()
      );
      rewardtobewithdraw = parseFloat(rewardtobewithdraw).toFixed(3);
      setStake_history((oldData) => {
        return { ...oldData, rewardtobewithdraw: rewardtobewithdraw };
      });

      let realtimeReward = await stakingContractOf.methods
        .totalRewardEarned()
        .call();

      realtimeReward = WebSupply.utils.fromWei(realtimeReward.toString());
      realtimeReward = parseFloat(realtimeReward).toFixed(5);
      setStake_history((oldData) => {
        return { ...oldData, realtimeReward: realtimeReward };
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Get_Stake_history();
  }, [address]);
  return (
    <div>
      <section className="card-section pb-5">
        <div className="container">
          <div className="heading-sec">
            <h2 className="sub-head ff-mos">Network Overview</h2>
          </div>
          <div className="grid-contain">
            <div className="row ff-mos">
              <div className="col-md-6 col-xl-4 col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>{Stake_history.TotalStaker}</span>
                    </div>
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total stakers</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>
                        <span>{Stake_history.TotalStakedToken}</span> BONE
                      </span>
                    </div>
                    <div className="mid-head">
                      <span />
                    </div>
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total staked token</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 mob-margin col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>
                        <span>{Stake_history.withdrawn}</span> BONE
                      </span>
                    </div>
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total withdrawn</span> BONE
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 mob-margin col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>
                        <span>{Stake_history.realtimeReward}</span> BONE
                      </span>
                    </div>
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total reward</span> BONE
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 mob-margin col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>
                        <span>{Stake_history.tvl}</span> BONE
                      </span>
                    </div>
                    {/* <div className="mid-head">
                      <span>10 min, 48 sec ago</span>
                    </div> */}
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total locked value</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 mob-margin col-custum">
                <div className="cus-box">
                  <div className="head-sec">
                    <div className="top-head">
                      <span>{Stake_history.rewardtobewithdraw} </span> BONE
                    </div>
                  </div>
                  <div className="botom-sec">
                    <div className="botom-headsec">
                      <span className="ff-mos">Total bone to be rewarded</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Network_overview;
